import React from 'react';
import { View } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';

import VerifyPaymentMethod from '@/components/verify-payment-method';

export default function VerifyPaymentMethodScreen() {
  const { styles } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <VerifyPaymentMethod />
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flexGrow: 1,
    backgroundColor: theme.colors.background_1,
  },
}));
